export { SliderGameCoreModule } from './slider-game-core.module';
export { SliderGameSelectorComponent } from './slider-game-selector/slider-game-selector.component';
export { SliderGameCoreService } from './slider-game-core.service';
export { ISliderGame } from './slider-game.interface';
